// eslint-disable-next-line max-len
var WEATHER_TEMPERATURE = 'M19.7,20.21v-.47L19.68,0H12.3l0,19.74v.46a6.48,6.48,0,1,0,7.38,0Zm-.53,8.48a4.48,4.48,0,1,1-5.36-7.08l.5-.29V19.75h0L14.3,2h3.38V5.36h-1.5a1,1,0,1,0,0,2h1.5V11h-1.5a1,1,0,1,0,0,2h1.5v8.33l.51.29a4.49,4.49,0,0,1,1,7.07Z';

export { WEATHER_TEMPERATURE };
//# sourceMappingURL=WEATHER_TEMPERATURE.js.map
